import { v4 as uuidv4 } from 'uuid';

const authChannel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('authChange') : null;
const clientId = uuidv4();

type AuthChangeMessage = {
  cid: string;
  message: string;
};

export function authChange() {
  authChannel?.postMessage(JSON.stringify({ cid: clientId, message: `authChange at ${new Date().toISOString()} from ${clientId}` }));
}

export function bindAuthChange(callback: (message: AuthChangeMessage) => void, cid = clientId) {
  const listener = (event: MessageEvent) => {
    const message = JSON.parse(event.data);
    if (message.cid !== cid) {
      callback(message);
    }
  };
  authChannel?.addEventListener('message', listener);
  return () => {
    authChannel?.removeEventListener('message', listener);
  };
}
